import { render, staticRenderFns } from "./Departmental-hidden-close.vue?vue&type=template&id=d0d3c7de"
import script from "./Departmental-hidden-close.vue?vue&type=script&lang=js"
export * from "./Departmental-hidden-close.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports